import { apiClient } from '@/lib/api/client';
import { API_ENDPOINTS } from '@/lib/api/config';
import type {
  AppSettings,
  ScanPageQuota,
  UpdateAppSettingsRequest
} from '../types';

const { CONFIGURATIONS } = API_ENDPOINTS;

export const configurationsApi = {
  getAll: () => apiClient.get<AppSettings>(CONFIGURATIONS.LIST),
  getScanPageQuota: () =>
    apiClient.get<ScanPageQuota>(CONFIGURATIONS.SCAN_PAGE_QUOTA),
  update: (data: UpdateAppSettingsRequest) =>
    apiClient.put<void>(CONFIGURATIONS.UPDATE, data)
};
